/**
 * @packageDocumentation
 * @module f1/string
 */

import { t_simple_value } from '../types';

// es6 variable
const es6Var = /\${(.*?)}/gi;
// human navigation format variable
const hnfVar = /:([a-z0-9\-\_]+)/gi;

export interface Template {
  /**
   * Dynamically evaluate an ES6 template
   *
   * @public
   * @function f1.template
   * @param template the template to evaluate
   * @param vars the variables to use when evaluating
   * @example
   *
   * ```ts
   * f1.template('${x} is a value', { x: 2 }) => '2 is a value'
   * f1.template(':x is a value', { x: 2 }) => '2 is a value'
   * ```
   */
  (template: string, vars: Record<string, t_simple_value>): string;
  (template: string): (vars: Record<string, t_simple_value>) => string;
}

/**
 * @see Template
 */
export default (template: string, vars: Record<string, t_simple_value>) =>
  template
    .replace(es6Var, (_: string, k: string) => `${vars[k]}`)
    .replace(hnfVar, (_: string, k: string) => `${vars[k]}`);
